import { useWeb3React } from '@web3-react/core';
import { ReactNode } from 'react';
import Spinner from '../../../components/Spinner';
import ExchangeListsErrowRow from './ExchangeListsErrorRow';

type ExchangeListsLoadingProps = {
    isLoading: boolean;
    message: string;
    children: ReactNode;
    error: Error | undefined;
};

const ExchangeListsStatus: React.FC<ExchangeListsLoadingProps> = ({
    isLoading,
    message,
    children,
    error,
}) => {
    const { account } = useWeb3React();

    return account ? (
        isLoading ? (
            <div className='row loading'>
                <Spinner />
                <span>Loading your {message}...</span>
            </div>
        ) : error ? (
            <ExchangeListsErrowRow message={`We had trouble loading your ${message}`} />
        ) : (
            <>{children}</>
        )
    ) : (
        <ExchangeListsErrowRow message={`Connect Wallet to view your ${message}`} />
    );
};

export default ExchangeListsStatus;
